import React from "react";
import "./About_us_we_connect.css"
function About_us_we_connect() {
  return (
    <>
      <section className="About_us_we_connect">
        <div className="container">
          <div className="row">
            <div className="col-md-7">
              <div className="text_holder">
                <div>
                <h5>We Connect Students to Top Online Universities </h5>
                <p>
                  and career-oriented programs while enabling our partners to
                  build sustainable, future-ready careers as education & career
                  advisors. Our model is built on trust, transparency, and
                  long-term value - ensuring success for students, partners, &
                  universities alike.
                </p>

                </div>
              </div>
            </div>

            <div className="col-md-5">
              <div className="img_holder">
                <img
                  className="connect_img"
                  src="/assets/images/about_us/about_us_we_connect/img_banner.png"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default About_us_we_connect;
